// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Action Buttons Improvements */
.action-cell {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
}

/* Fixed width action buttons */
.action-button,
.view-button, 
.checklist-button, 
.exam-button,
.close-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 36px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 12px;
  box-sizing: border-box;
}

/* Button colors */
.view-button {
  background-color: #e0f2ff;
  color: #0077cc;
}

.view-button:hover {
  background-color: #d0e9ff;
}

.close-button {
  background-color: #f1f5f9;
  color: #64748b;
}

.close-button:hover {
  background-color: #e2e8f0;
}

.checklist-button {
  background-color: #fef9c3;
  color: #d97706;
}

.checklist-button:hover {
  background-color: #fef3c7;
}

.exam-button {
  background-color: #e0e7ff;
  color: #4f46e5;
}

.exam-button:hover {
  background-color: #d1d9ff;
}

.pagination-container {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  padding: 15px 0;
  margin-left: 250px; 
  z-index: 90;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  padding: 8px 12px;
}

/* Mobile responsiveness for pagination */
@media (max-width: 992px) {
  .pagination-container {
    margin-left: 80px; /* Adjust based on collapsed sidebar width */
  }
}

@media (max-width: 576px) {
  .pagination-container {
    margin-left: 0;
    bottom: 70px; /* Adjust to be above mobile navigation */
  }
  
  .action-button,
  .view-button, 
  .checklist-button, 
  .exam-button,
  .close-button {
    width: 100%; /* Full width on mobile */
  }
  
  .action-cell {
    flex-direction: column;
    align-items: stretch;
  }
}

/* Adjust table bottom padding to prevent content being hidden by pagination */
.main-content {
  padding-bottom: 90px;
}

/* Table improvements for consistent row heights */
.data-table td {
  vertical-align: middle;
  height: 60px; /* Maintain consistent height */
}

/* Improved active state for pagination buttons */
.pagination-button.active {
  background-color: #1e3a8a;
  color: white;
  border-color: #1e3a8a;
  box-shadow: 0 2px 5px rgba(30, 58, 138, 0.3);
}

/* Status badges */
.status-badge {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  margin-right: 10px;
  transition: all 0.3s ease;
  cursor: default;
}

.status-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.status-passed, .status-approved {
  background-color: #28a745;
  color: white;
  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);
  border: 1px solid #1e7e34;
}

.status-passed:hover, .status-approved:hover {
  background-color: #218838;
}

.status-failed, .status-rejected {
  background-color: #dc3545;
  color: white;
  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);
  border: 1px solid #c82333;
}

.status-failed:hover, .status-rejected:hover {
  background-color: #c82333;
}

.status-pending {
  background-color: #ffc107;
  color: #212529;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
  border: 1px solid #e0a800;
}

.status-pending:hover {
  background-color: #0f4dd4;
}

.status-review {
  background-color: #17a2b8;
  color: white;
  box-shadow: 0 2px 4px rgba(23, 162, 184, 0.3);
  border: 1px solid #138496;
}

.status-review:hover {
  background-color: #138496;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Admin Dashboard/ImprovedDashboard.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;;;;;EAKE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA,yCAAyC;AACzC;EACE;IACE,iBAAiB,EAAE,4CAA4C;EACjE;AACF;;AAEA;EACE;IACE,cAAc;IACd,YAAY,EAAE,yCAAyC;EACzD;;EAEA;;;;;IAKE,WAAW,EAAE,yBAAyB;EACxC;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;AACF;;AAEA,8EAA8E;AAC9E;EACE,oBAAoB;AACtB;;AAEA,kDAAkD;AAClD;EACE,sBAAsB;EACtB,YAAY,EAAE,+BAA+B;AAC/C;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Action Buttons Improvements */\r\n.action-cell {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  padding: 10px 0;\r\n}\r\n\r\n/* Fixed width action buttons */\r\n.action-button,\r\n.view-button, \r\n.checklist-button, \r\n.exam-button,\r\n.close-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 150px;\r\n  height: 36px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  border-radius: 6px;\r\n  border: none;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  padding: 0 12px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Button colors */\r\n.view-button {\r\n  background-color: #e0f2ff;\r\n  color: #0077cc;\r\n}\r\n\r\n.view-button:hover {\r\n  background-color: #d0e9ff;\r\n}\r\n\r\n.close-button {\r\n  background-color: #f1f5f9;\r\n  color: #64748b;\r\n}\r\n\r\n.close-button:hover {\r\n  background-color: #e2e8f0;\r\n}\r\n\r\n.checklist-button {\r\n  background-color: #fef9c3;\r\n  color: #d97706;\r\n}\r\n\r\n.checklist-button:hover {\r\n  background-color: #fef3c7;\r\n}\r\n\r\n.exam-button {\r\n  background-color: #e0e7ff;\r\n  color: #4f46e5;\r\n}\r\n\r\n.exam-button:hover {\r\n  background-color: #d1d9ff;\r\n}\r\n\r\n.pagination-container {\r\n  position: fixed;\r\n  bottom: 20px;\r\n  left: 0;\r\n  right: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  padding: 15px 0;\r\n  margin-left: 250px; \r\n  z-index: 90;\r\n}\r\n\r\n.pagination-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: #fff;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\r\n  padding: 8px 12px;\r\n}\r\n\r\n/* Mobile responsiveness for pagination */\r\n@media (max-width: 992px) {\r\n  .pagination-container {\r\n    margin-left: 80px; /* Adjust based on collapsed sidebar width */\r\n  }\r\n}\r\n\r\n@media (max-width: 576px) {\r\n  .pagination-container {\r\n    margin-left: 0;\r\n    bottom: 70px; /* Adjust to be above mobile navigation */\r\n  }\r\n  \r\n  .action-button,\r\n  .view-button, \r\n  .checklist-button, \r\n  .exam-button,\r\n  .close-button {\r\n    width: 100%; /* Full width on mobile */\r\n  }\r\n  \r\n  .action-cell {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n}\r\n\r\n/* Adjust table bottom padding to prevent content being hidden by pagination */\r\n.main-content {\r\n  padding-bottom: 90px;\r\n}\r\n\r\n/* Table improvements for consistent row heights */\r\n.data-table td {\r\n  vertical-align: middle;\r\n  height: 60px; /* Maintain consistent height */\r\n}\r\n\r\n/* Improved active state for pagination buttons */\r\n.pagination-button.active {\r\n  background-color: #1e3a8a;\r\n  color: white;\r\n  border-color: #1e3a8a;\r\n  box-shadow: 0 2px 5px rgba(30, 58, 138, 0.3);\r\n}\r\n\r\n/* Status badges */\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 5px 10px;\r\n  border-radius: 50px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  margin-right: 10px;\r\n  transition: all 0.3s ease;\r\n  cursor: default;\r\n}\r\n\r\n.status-badge:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.status-passed, .status-approved {\r\n  background-color: #28a745;\r\n  color: white;\r\n  box-shadow: 0 2px 4px rgba(40, 167, 69, 0.3);\r\n  border: 1px solid #1e7e34;\r\n}\r\n\r\n.status-passed:hover, .status-approved:hover {\r\n  background-color: #218838;\r\n}\r\n\r\n.status-failed, .status-rejected {\r\n  background-color: #dc3545;\r\n  color: white;\r\n  box-shadow: 0 2px 4px rgba(220, 53, 69, 0.3);\r\n  border: 1px solid #c82333;\r\n}\r\n\r\n.status-failed:hover, .status-rejected:hover {\r\n  background-color: #c82333;\r\n}\r\n\r\n.status-pending {\r\n  background-color: #ffc107;\r\n  color: #212529;\r\n  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);\r\n  border: 1px solid #e0a800;\r\n}\r\n\r\n.status-pending:hover {\r\n  background-color: #0f4dd4;\r\n}\r\n\r\n.status-review {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  box-shadow: 0 2px 4px rgba(23, 162, 184, 0.3);\r\n  border: 1px solid #138496;\r\n}\r\n\r\n.status-review:hover {\r\n  background-color: #138496;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
